
  import { mapGetters } from 'vuex'
  import cms from '~/mixins/common/cms'
  export default {
    mixins: [cms],
    computed: {
      ...mapGetters({
        inviteAndEarnBanner: 'cms/inviteAndEarnBanner'
      })
    }
  }
